import { Component } from '../../../engine/Component';

export default class TopMenuComponent extends Component {
  static get code(): string {
    return 'top_menu';
  }
}
